export interface CurrencyRate {
  responseData: {
    rate: number;
  };
}
